<template>
  <icon-base
    :title="title"
    :name="name"
    :viewbox="viewBox">
    



<g>
	<path d="M2.25,21.25C1.009,21.25,0,20.241,0,19v-2.309c0.001-0.736,0.527-1.357,1.252-1.479c1.266-0.211,2.257-1.202,2.468-2.467
		c0.131-0.789-0.053-1.584-0.52-2.237C2.734,9.855,2.042,9.423,1.253,9.292C0.526,9.171,0,8.549,0,7.813V5.5
		c0-1.241,1.009-2.25,2.25-2.25h19.5C22.991,3.25,24,4.259,24,5.5v2.311c-0.001,0.735-0.527,1.357-1.252,1.479
		c-1.448,0.245-2.499,1.49-2.498,2.96c0,1.469,1.051,2.713,2.5,2.959c0.724,0.12,1.25,0.742,1.25,1.478V19
		c0,1.241-1.009,2.25-2.25,2.25H2.25z M2.25,4.75C1.836,4.75,1.5,5.086,1.5,5.5v2.313C2.683,8.01,3.721,8.657,4.42,9.637
		s0.976,2.171,0.779,3.355c-0.316,1.897-1.803,3.384-3.7,3.7L1.5,19c0,0.414,0.336,0.75,0.75,0.75h19.5
		c0.414,0,0.75-0.336,0.75-0.75v-2.313c-2.173-0.368-3.75-2.234-3.75-4.437c-0.001-2.204,1.575-4.071,3.749-4.44L22.5,5.5
		c0-0.414-0.336-0.75-0.75-0.75H2.25z"/>
	<path d="M15.75,18.25c-0.414,0-0.75-0.336-0.75-0.75V16c0-0.414,0.336-0.75,0.75-0.75S16.5,15.586,16.5,16v1.5
		C16.5,17.914,16.164,18.25,15.75,18.25z"/>
	<path d="M15.75,13.75C15.336,13.75,15,13.414,15,13v-1.5c0-0.414,0.336-0.75,0.75-0.75s0.75,0.336,0.75,0.75V13
		C16.5,13.414,16.164,13.75,15.75,13.75z"/>
	<path d="M15.75,9.25C15.336,9.25,15,8.914,15,8.5V7c0-0.414,0.336-0.75,0.75-0.75S16.5,6.586,16.5,7v1.5
		C16.5,8.914,16.164,9.25,15.75,9.25z"/>
	<path d="M8.25,18.25c-0.414,0-0.75-0.336-0.75-0.75V16c0-0.414,0.336-0.75,0.75-0.75C8.664,15.25,9,15.586,9,16v1.5
		C9,17.914,8.664,18.25,8.25,18.25z"/>
	<path d="M8.25,13.75c-0.414,0-0.75-0.336-0.75-0.75v-1.5c0-0.414,0.336-0.75,0.75-0.75C8.664,10.75,9,11.086,9,11.5V13
		C9,13.414,8.664,13.75,8.25,13.75z"/>
	<path d="M8.25,9.25C7.836,9.25,7.5,8.914,7.5,8.5V7c0-0.414,0.336-0.75,0.75-0.75C8.664,6.25,9,6.586,9,7v1.5
		C9,8.914,8.664,9.25,8.25,9.25z"/>
</g>


  </icon-base>
</template>

<script>
import IconBase from '../IconBase';

export default {
  components: {
    IconBase,
  },
  props: {
    title: {
      type: String,
      required: false,
      default: 'ticket',
    },
    name: {
      type: String,
      required: false,
      default: 'Ticket',
    },
    viewBox: {
      type: String,
      required: false,
      default: '0 0 24 24',
    },
  },
};
</script>

<style scoped>
  
</style>